// extracted by mini-css-extract-plugin
module.exports = {"parent":"SpaceBetween_parent__1Z7Zi"};